import { Sms } from 'app/sms/sms-service/sms.model';

export class SetActiveThreadBorrowerId {
  static readonly type = '[UserSmsThreads] SetActiveThreadBorrowerId';
  constructor(
    public newBorrowerId: number,
    public filterUnread?: boolean,
  ) {}
}

export class SetActiveUnknownSms {
  static readonly type = '[UserSmsThreads] SetActiveUnknownSms';
  constructor(
    public sms: Sms
  ) {
  }
}

export class UnsetActiveUnknownSms {
  static readonly type = '[UserSmsThreads] UnsetActiveUnknownSms';
  constructor() {}
}

export class GetUserSmsThreads {
  static readonly type = '[UserSmsThreads] GetUserThreads';
  constructor(
    public lenderUserId: number,
    public reset: boolean = true,
    public page: number = 1,
    public filterBy: string = 'unread',
    public sortDirection: string = 'desc',
  ) {}
}

export class NotifySmsThreadRead {
  static readonly type = '[UserSmsThreads] NotifySmsThreadRead';
  constructor( public borrowerId ) {}
}

export class NotifySmsThreadUnread {
  static readonly type = '[UserSmsThreads] NotifySmsThreadUnread';
  constructor( public borrowerId, public unreadCount ) {}
}


export class NotifyUnknownSmsRead {
  static readonly type = '[UserSmsThreads] NotifyUnknownSmsRead';
  constructor(
    public smsId: number
  ) {}
}

export class NotifyUnknownSmsUnread {
  static readonly type = '[UserSmsThreads] NotifyUnknownSmsUnread';
  constructor() {}
}

export class UnsetActiveUserSms {
  static readonly type = '[UserSmsThreads] UnsetActiveUserSms';
  constructor() {}
}

export class GetUserUnknownSms {
  static readonly type = '[UserUnknownSms] GetUserUnknownSms';
  constructor(
    public lenderUserId: number,
    public reset: boolean = true,
    public page: number = 1,
    public sortDirection: string = 'desc',
  ) {}
}
